var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.status_screen, _vm.$style[_vm.status]]},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.passed ? 'status.pass' : 'status.fail')))])])}
var staticRenderFns = []

export { render, staticRenderFns }